@use '@repo/sds/styles/tokens/mixins' as *;

.SDSTextArea {
  display: flex;
  background: var(--background-fill);
  padding: var(--padding-input-field-input-medium);
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: var(--border-radius-input-medium);
  border: 1px solid var(--input-default);
  box-shadow: none;
  width: 100%;
  resize: vertical;
  min-height: 100px;
  outline: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;

  &::placeholder {
    color: var(--text-inactive);
    font-size: var(--font-size-medium-small, 18px);
    font-style: normal;
    font-weight: 500;
  }

  transition:
    border-color 0.4s ease,
    color 0.4s ease;

  &:hover {
    border-color: var(--input-hover);
  }

  &:active,
  &:focus-visible,
  &:focus-within {
    border-color: var(--brand-primary);
  }

  @include text-input-state-styles;

  &__container {
    display: inline-flex;
    flex-direction: column;
    gap: var(--gaps-text-small);

    &--fullWidth {
      width: 100%;
    }
  }
}
